

import axios, { AxiosResponse } from 'axios';
import _ from 'lodash'

export default class ThermalPrinterBase {
    // apiUrl: string = "http://192.168.0.181:9090";
    // apiUrl: string = "http://192.168.2.130:9090";
    apiUrl: string = "http://localhost:9090";
    path: string = "/thermal"
    print_queues = []


    // ตรวจสอบ item ที่ใช้
    getPrintersThatUsed(items: any) {
        const printers: any = []
        items.forEach((item: any) => {
            printers.push(item.printer)
        })
        return  _.compact(printers)
    }

    print() {
        let printerPort = localStorage.getItem('printerPort')
        if(printerPort && printerPort!==""){
            this.apiUrl = "http://localhost:" + printerPort
        }

        this.print_queues.forEach(cmd => {
            axios.post(this.apiUrl + this.path + '/document', cmd)
                .then((response: AxiosResponse) => {
                })
                .catch((error) => {
                    console.log(error)
                })
        })

    }
}

// Nuxt auto-import (unimport) ลงทะเบียนชื่อคลาสนี้เป็น named export
// จึงต้อง export ชื่อออกไปด้วย ไม่งั้น build จะ resolve ไม่เจอ
// ส่วน default export ตัวเดิมยังอยู่ ผู้ที่ import แบบเดิมไม่กระทบ
export { ThermalPrinterBase };
